import type { ObservationDocument } from './observation-document.type.ts';

export interface ObservationDocumentExtension extends ObservationDocument {}
export class ObservationDocumentExtension {
  // ── Computed ──
  get isSuppressed(): boolean {
    return Boolean(this.discardedAt);
  }
}

const Registration = {
  kind: 'object',
  name: 'observation-document',
  features: ObservationDocumentExtension,
};
export default Registration;
